export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-4 border-t border-border px-4 py-6 text-center text-sm text-muted">
      <p>&copy; {year} ElisTech</p>
    </footer>
  );
}
